import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZakazkovyList = {
	name: NAME,
	apiProvider,
	router,
};
